import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CanCreateAccountDirective } from './can-create-account.directive';

@NgModule({
  declarations: [CanCreateAccountDirective],
  exports: [CanCreateAccountDirective],
  imports: [CommonModule],
})
export class CanCreateAccountModule {}
